module.exports = __webpack_public_path__ + "img/stop_capture.4a9b0ebf.svg";